import React from 'react';
import ReactDOM from 'react-dom';
import NoContentIcon from '../assets/icons/NoContentIcon.svg';

function NoCardsMessage(): JSX.Element {
    return (
        <>
            <div className="icon-wrapper">
                <img
                    src={NoContentIcon}
                    alt="announcement-loudspeaker-icon"
                    className="no-content-icon"
                />
            </div>
            <div className="no-content-text">
                <div className="no-content-title">
                    Nothing to see here (yet)!
                </div>
                <div className="no-content-description">
                    We’ll be sure to let you know when we have something for you
                </div>
            </div>
        </>
    );
}

export function renderCustomNoCardsMessage(): void {
    const containerEl = document.querySelector('.ab-no-cards-message');
    if (!containerEl) return;

    const existingRender = document.getElementById(
        'no-cards-message-container',
    );
    if (existingRender) return;

    // Clear any default Braze message
    containerEl.innerHTML = '';

    // Set up container
    const customContainer = document.createElement('div');
    customContainer.id = 'no-cards-message-container';
    containerEl.appendChild(customContainer);

    // Render custom message inside the container
    ReactDOM.render(<NoCardsMessage />, customContainer);
}
